import React from 'react';
import PropTypes from 'prop-types';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import './userManagement.scss';

const UserDataGrid = ({
  filteredRows,
  columns,
  handleRowSelectionChange,
  isEdit,
  checkboxDisabled,
  dataColumns,
}) => (
  <div className="users-data-grid-container">
    {filteredRows && (
      <DataGridComponent
        dataRows={filteredRows}
        dataColumns={dataColumns}
        isFilteredRows={filteredRows}
        sortFilterColumns={columns.map((column) => column.field)}
        pageSize={10}
        dataGridCheckbox
        onRowSelectionChange={handleRowSelectionChange}
        gridCheckbox
        dataGridCss="user-management-data-grid"
        isEdit={isEdit}
        checkboxDisabled={checkboxDisabled}
        excludeSuperAdmin
      />
    )}
  </div>
);

UserDataGrid.propTypes = {
  filteredRows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  handleRowSelectionChange: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  checkboxDisabled: PropTypes.bool,
  dataColumns: PropTypes.array.isRequired,
};

export default UserDataGrid;
